import axios from 'axios';
import { createContext } from 'react';

export const API_URL = process.env.REACT_APP_CLIENT_API_URL
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL


// axios config function
export const axiosNodeClient = axios.create({
    baseURL: API_URL,
    headers: {
        "content-type": "application/json",
    },
    data: null,
    proxy: undefined
});

axiosNodeClient.interceptors.request.use((config) => {
    const authToken = localStorage.getItem('auth_code');

    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
});

axiosNodeClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && localStorage.getItem('auth_code')) {
            localStorage.removeItem("fmpfp_therapist_obj");
            localStorage.removeItem("auth_code");
            localStorage.removeItem("b_n");

            window.location.pathname = "/";
        }

        return Promise.reject(error);
    }
);

